export function sleep(ms: number, signal?: AbortSignal): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    let onAbort: (() => void) | undefined;
    const timeout = setTimeout(() => {
      if (onAbort) {
        signal?.removeEventListener("abort", onAbort);
      }
      resolve();
    }, ms);

    if (signal) {
      if (signal.aborted) {
        clearTimeout(timeout);
        return reject(new DOMException("Aborted", "AbortError"));
      }
      onAbort = (): void => {
        clearTimeout(timeout);
        reject(new DOMException("Aborted", "AbortError"));
      };
      signal.addEventListener("abort", onAbort, { once: true });
    }
  });
}
